import {
  DispatchDispatchRequestAssocStatusType,
  dispatchDispatchRequestAssocStatusTypes,
  dispatchRequestStatus
} from "@ots-frontend/ots-data";
import {Badge} from "../Badge/Badge";
import {useMemo} from "react";
import {getDispatchRequestStatusColorRef} from "../../../util/dispatch-request-ui-util";

export type DispatchDispatchRequestAssocStatusBadgeProps = {
  status: DispatchDispatchRequestAssocStatusType
}

export const DispatchDispatchRequestAssocStatusBadge = (props: DispatchDispatchRequestAssocStatusBadgeProps) => {
  const {status} = props;

  const color = useMemo(() => {
    switch (status) {
      case dispatchDispatchRequestAssocStatusTypes.scheduled:
        return getDispatchRequestStatusColorRef(dispatchRequestStatus.pending)
      case dispatchDispatchRequestAssocStatusTypes.started:
        return getDispatchRequestStatusColorRef(dispatchRequestStatus.started)
      case dispatchDispatchRequestAssocStatusTypes.pickup:
        return getDispatchRequestStatusColorRef(dispatchRequestStatus.pickedUp)
      case dispatchDispatchRequestAssocStatusTypes.complete:
        return getDispatchRequestStatusColorRef(dispatchRequestStatus.completed)
      case dispatchDispatchRequestAssocStatusTypes.canceled:
        return getDispatchRequestStatusColorRef(dispatchRequestStatus.canceled)
    }
  }, [status])

  // TODO: status display value should be localized
  return (
    <Badge color={color} variant="filled">
      {status.displayValue}
    </Badge>
  );
};
